import offscreenCanvas from './offscreenCanvas';

export default { offscreenCanvas };
